export function logError(error) {
  const date = new Date();
  console.error(`${date.toLocaleDateString()} ${date.toLocaleTimeString()}`, JSON.stringify(error));
  console.error(error);
}
